import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { select, Store } from '@ngrx/store';
import { AppState, selectUserTheme } from '@app/core/ngrx';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ecp-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent {
  // @select(['user', 'profile', 'theme'])
  public theme$: Observable<string>;
  /**
   * constructor
   * @param {MatDialogRef<AlertDialogComponent>} dialogRef
   * @param data
   */
  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.theme$ = this.store.pipe(select(selectUserTheme));
  }

  /**
   * closeDialog
   */
  @HostListener('document:keydown.escape')
  closeDialog() {
    this.dialogRef.close();
  }
}
